import "./Loading.scss";
import { DirectiveBinding } from "vue/types/options";

function addClass(el: HTMLElement): void {
  el.classList.add("is-loading");
  el.classList.add("default-loader");
  el.setAttribute("disabled", "disabled");
}

function removeClass(el: HTMLElement): void {
  el.classList.remove("is-loading");
  el.classList.remove("default-loader");
  el.removeAttribute("disabled");
}

export default {
  bind(el: HTMLElement, binding: DirectiveBinding): void {
    binding.value && addClass(el);
  },

  update(el: HTMLElement, binding: DirectiveBinding) {
    binding.value ? addClass(el) : removeClass(el);
  }
};
